import qs, { ParsedQs } from 'qs';
import { useLocation } from 'react-router-dom';

const VALID_FORMAT_REGEX = /(shipment|order):\w+/;

interface BaseRelatedView {
  searchParam: ParsedQs[string];
}

type ValidRelatedView = BaseRelatedView & {
  listView: 'shipment' | 'order';
  listViewId: string;
  isValid: true;
};

type InvalidRelatedView = BaseRelatedView & {
  listView: null;
  listViewId: null;
  isValid: false;
};

export function useRelatedViewParam(): ValidRelatedView | InvalidRelatedView {
  const location = useLocation();
  const { relatedView } = qs.parse(location.search.replace(/\+/g, '%2B'), {
    ignoreQueryPrefix: true,
  });
  if (
    relatedView &&
    typeof relatedView === 'string' &&
    VALID_FORMAT_REGEX.test(relatedView)
  ) {
    const [listView, listViewId] = relatedView.split(':');
    return {
      listView: listView as ValidRelatedView['listView'],
      listViewId,
      isValid: true,
      searchParam: relatedView,
    };
  }
  return {
    listView: null,
    listViewId: null,
    isValid: false,
    searchParam: relatedView,
  };
}

export const getHeaders = <T extends { id: string }>(headers: T[]) => {
  return headers.filter(
    ({ id }) => !(id === 'related-shipments' || id === 'related-orders'),
  );
};
